import { AxiosResponse } from 'axios'
import api from './api'
import { IPaymentType } from 'models/payment.model'

const getUrlStripe = (product = 'protexxa_scan'): Promise<AxiosResponse> => {
  return api.post<string>('/v1/payments/intent', { product })
}

export const getUrlStripeManager = (): Promise<AxiosResponse> => {
  return api.post<string>('/v1/payments/manager')
}

const getListPayments = (): Promise<AxiosResponse> => {
  return api.get<IPaymentType>('/v1/payments/list')
}

export default {
  getUrlStripe,
  getUrlStripeManager,
  getListPayments,
}
